import axios from "axios";
import { ApiConfig } from "../../../services/api-config";
import CookieUtils from "../../../utils/cookie-utils";

/**
 * Tải file Excel mà order service tạo và trả ngay trong request (không chạy nền) — vd báo cáo sản lượng.
 * Tên file lấy từ `Content-Disposition` của BE; lỗi (trả về dạng blob JSON) được đọc ra để ném đúng thông báo
 * của BE (vd "Mỗi lần xuất tối đa 93 ngày").
 */
export async function downloadOrderServiceExcel(
  endPoint: string,
  params: Record<string, unknown>,
  fallbackName: string,
  /** Service sinh file — mặc định order; vd sổ quỹ dùng accounting. */
  projectId: string | number = ApiConfig.PROJECT_ID.ORDER_SERVICE,
) {
  try {
    const token = CookieUtils.getCurrentUser().access_token ?? "";
    const res = await axios.get(`${ApiConfig.API_URL}/api/${endPoint}`, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
        "x-svc-id": projectId,
        platform: "1",
      },
      responseType: "blob",
    });
    const disposition = String(res.headers["content-disposition"] || "");
    const match = disposition.match(/filename\*=UTF-8''([^;]+)/);
    const url = window.URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = match ? decodeURIComponent(match[1]) : fallbackName;
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (e: any) {
    let message = "Xuất Excel thất bại";
    try {
      const body = JSON.parse(await e?.response?.data?.text());
      if (body?.message) message = body.message;
    } catch {}
    throw new Error(message);
  }
}
